export const OfferletterCreate = `mutation OnboardCalculateEmployeeSalary(
  $recruitmentProcessId: ID!
  $salaryStructureId: ID!
  $ctc: Float!
  $basicPercentage: Float!
  $date: Date
) {
  onboardCalculateEmployeeSalary(
    recruitmentProcessId: $recruitmentProcessId
    salaryStructureId: $salaryStructureId
    ctc: $ctc
    basicPercentage: $basicPercentage
    date: $date
  ) {
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    date 
    breakdown 
  }
}`;

export const ALL_SALARY_STRUCTURE = `
query allsalarystructure{
salaryStructures {
id
structureName
components {
  id
  percentage
  amount
  type
  calculatedFrom
  }
}
}
`;

export const PaySlipGetID = `query GetRecruitmentProcessById($id: ID!) {
  recruitmentProcessById(id: $id) {
    id
    sourcingScreening {
      id
      candidateName
      screeningStatus
    }
    screening
    payslipFile
    technicalInterview
    interviewStatus
    offerLetter
    onBording
    assertRequest
    documentVerification
    appointmentLetter
    nda
    hrInduction
    technicalInduction
    teamIntro
    assestHandover
    hrmsAccess
    handoverToManager
  }
}
`;

export const AllPayslip = `query {
  allRecruitmentProcesses {
    id
  sourcingScreening {
      id
      candidateName
      screeningStatus
    }
    screening
    payslipFile
    technicalInterview
    interviewStatus
    offerLetter
    onBording
    assertRequest
    documentVerification
    appointmentLetter
    nda
    hrInduction
    technicalInduction
    teamIntro
    assestHandover
    hrmsAccess
    handoverToManager    
  }
}
`;

export const Deletepayslip = `mutation DeleteRecruitmentProcess($id: ID!) {
  deleteRecruitmentProcess(id: $id) {
    success
    message
  }
}
`;
export const Allstaffrequestquery = `query {
  allStaffRequests {
    id
    jobid
    requestDate
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
  }
}`;

export const UpdatePayslip = `mutation UpdateRecruitmentProcess($id: ID!, $input: RecruitmentProcessInput!) {
  updateRecruitmentProcess(id: $id, input: $input) {
    recruitmentProcess {
      id
      screening
      technicalInterview
      interviewStatus
      offerLetter
      onBording
      assertRequest
      documentVerification
      appointmentLetter
      nda
      hrInduction
      technicalInduction
      teamIntro
      assestHandover
      hrmsAccess
      handoverToManager
    }
    success
    message
  }
}
`;

export const GetAllTechnical = `query GetAllTechnicalFeedback {
  allTechnicalFeedback {
    id
    comments
    hiringStatus
    professionalism
    technicalSkills
    communication
    sourcingScreening {
      id
      candidateName
    }
  }
}`;

export const CreateAppoinment = `mutation CreateAppointmentLetter( 

  $input: CreateAppointmentLetterInput! 

) { 

  createAppointmentLetter(input: $input) { 

    empCode 

    date 

    ctc 

    gross 

    totalDeductions 

    totalBenefits 

    netPay 

    overallSum 

    difference 

    breakdown    

  } 

} `;

export const GetOfferSalary = `query GetOfferSalaryById($id: Int!) {
  offerSalary(id: $id) {
    id
    recruitmentProcess {
      id
    }
    salaryStructure {
      id
    }
    basicPercentage
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    date
    overallSum
    difference
    breakdown
  }
}`

export const AllofferSalary = `query GetAllOfferSalaries {
  allOfferSalaries {
    id
    recruitmentProcess {
      id
    }
    salaryStructure {
      id
    }
    basicPercentage
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    breakdown
  }
}`

export const UpdateOfferLetter = `mutation UpdateSalary($input: UpdateOnboardEmployeeSalaryInput!) { 
  updateOnboardEmployeeSalary(input: $input) { 
    id 
    ctc 
    gross 
    netPay 
    totalDeductions 
    totalBenefits 
    overallSum 
    breakdown 
  } 
} `

export const Allappointmentquery = `query GetAllAppointmentLetters { 

  allAppointmentLetters { 

    id 

    recruitmentProcess { 

      id 

       

    } 

    salaryStructure { 

      id 

       

    } 

    ctc 

    basicPercentage 

    empCode 

    date 

    gross 

    totalDeductions 

    totalBenefits 

    netPay 

    overallSum 

    difference 

    breakdown 

  } 

} `

export const GetAppointment = `query GetAppointmentLetterById($id: Int!) { 

  appointmentLetter(id: $id) { 

    id 

    recruitmentProcess { 

      id 

    } 

    salaryStructure { 

      id 

    } 

    ctc 

    basicPercentage 

    empCode 

    date 

    gross 

    totalDeductions 

    totalBenefits 

    netPay 

    overallSum 

    difference 

    breakdown 

  } 

} 

  `

  export const UpdateAppointment = `mutation UpdateAppointmentLetter($input: UpdateAppointmentLetterInput!) { 

  updateAppointmentLetter(input: $input) { 

    empCode 

    date 

    ctc 

    gross 

    totalDeductions 

    totalBenefits 

    netPay 

    overallSum 

    difference 

    breakdown    

  } 

} 

 `

 export const UpdateSourceScreen = `   mutation UpdateSourcingScreening($id: ID!, $input: SourcingScreeningInput!) {
        updateSourcingScreening(id: $id, input: $input) {
          sourcingScreening {
            id
            jobid
            candidateName
            source
            emailid
            mobileNumber
            totalExperience
            relevantExperience
            currentCtc
            expectedCtc
            leadTime
            yearOfPassing
            currentEmployer
            location
            comments
            interviewAvailability
            interviewer
          }
        }
      }`

export const allempquery = `query{
        allUsersDetail{
        id
        lastLogin
        username
        firstName
        lastName
        isActive
        dateJoined
        email
        salutation
        dateOfBirth
        contactNumber
        emergencyContact
        gender
        employeeType
        lastUpdate
        department
        designation
        empid
        teamleader 
        grade
        role{
        role
        }
        }}`

 